<template>
  <div class="modal-container clearfix">
    <div class="block">
      <div class="block-tip"></div>
      <span class="block-title">基础信息</span>
    </div>
    <vxe-form
        ref="xForm"
        class="my-form2"
        title-align="right"
        title-width="200"
        :data="formData">
      <vxe-form-item title="单证号" field="carNum" span="12">
        <template>
          <span>{{formData.documentNumber}}</span>
        </template>
      </vxe-form-item>
      <vxe-form-item title="资金流水上传时间" field="sendToProDateTime" span="12">
        <template>
          <span>{{formData.sendToProDateTime}}</span>
        </template>
      </vxe-form-item>
      <vxe-form-item title="实际承运人名称" field="carrier" span="12">
        <template>
          <span>{{formData.carrier}}</span>
        </template>
      </vxe-form-item>
      <vxe-form-item title="统一社会信用代码或证件号码" field="actualCarrierId" span="12">
        <template>
          <span>{{formData.actualCarrierId}}</span>
        </template>
      </vxe-form-item>
      <vxe-form-item title="车牌号" field="vehicleNumber" span="12">
        <template>
          <span>{{formData.vehicleNumber}}</span>
        </template>
      </vxe-form-item>
      <vxe-form-item title="车牌颜色" field="vehiclePlateColorCode" span="12">
        <template>
          <span>{{formData.vehiclePlateColorCodeText}}</span>
        </template>
      </vxe-form-item>
      <vxe-form-item title="备注" field="remark" span="12">
        <template>
          <span>{{formData.remark}}</span>
        </template>
      </vxe-form-item>
    </vxe-form>
    <div class="block">
      <div class="block-tip"></div>
      <span class="block-title">运单列表</span>
    </div>
    <vxe-table
        border
        show-overflow
        ref="xTable1"
        class="table-style"
        max-height="480"
        :auto-resize="true"
        align="center"
        :data="capList"
    >
      <vxe-table-column field="shippingNoteNumber" title="运单号"></vxe-table-column>
      <vxe-table-column field="serialNumber" title="分段分单号"></vxe-table-column>
      <vxe-table-column field="totalMonetaryAmount" title="总金额"></vxe-table-column>
    </vxe-table>
    <div class="block">
      <div class="block-tip"></div>
      <span class="block-title">财务列表</span>
    </div>
    <div class="add-box clearfix">
      <vxe-table
          border
          show-overflow
          ref="xTable2"
          class="table-style"
          max-height="480"
          :auto-resize="true"
          align="center"
          :data="payList"
          :edit-rules="formRules"
      >
        <vxe-table-column field="paymentMeansCode" title="付款方式代码">
          <template v-slot:header>
            <span style="color: red">*</span>付款方式代码
          </template>
          <template v-slot="scope">
            <vxe-select v-if="isEdit" v-model="scope.row.paymentMeansCode" transfer>
              <vxe-option v-for="(item,index) in payment_code" :key="index" :value="item.value"
                          :label="item.label"></vxe-option>
            </vxe-select>
            <span v-else>{{scope.row.paymentMeansCodeText}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="recipient" title="收款方名称">
          <template v-slot:header>
            <span style="color: red">*</span>收款方名称
          </template>
          <template v-slot="scope">
            <vxe-input v-if="isEdit" v-model="scope.row.recipient" placeholder="请输入" @blur="clearV"></vxe-input>
            <span v-else>{{scope.row.recipient}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="receiptAccount" title="收款账户信息">
          <template v-slot:header>
            <span style="color: red">*</span>收款账户信息
          </template>
          <template v-slot="scope">
            <vxe-input v-if="isEdit" v-model="scope.row.receiptAccount" placeholder="请输入" @blur="clearV"></vxe-input>
            <span v-else>{{scope.row.receiptAccount}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="bankCode" title="收款方银行代码">
          <template v-slot="scope">
            <vxe-select v-if="isEdit" v-model="scope.row.bankCode" transfer>
              <vxe-option v-for="(item,index) in bank_code" :key="index" :value="item.value"
                          :label="item.label"></vxe-option>
            </vxe-select>
            <span v-else>{{scope.row.bankCodeText}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="sequenceCode" title="流水号/序列号">
          <template v-slot:header>
            <span style="color: red">*</span>流水号/序列号
          </template>
          <template v-slot="scope">
            <vxe-input v-if="isEdit" v-model="scope.row.sequenceCode" placeholder="请输入" @blur="clearV"></vxe-input>
            <span v-else>{{scope.row.sequenceCode}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="monetaryAmount" title="实际支付金额">
          <template v-slot:header>
            <span style="color: red">*</span>实际支付金额
          </template>
          <template v-slot="scope">
            <vxe-input v-if="isEdit" v-model="scope.row.monetaryAmount" placeholder="请输入" @blur="clearV"></vxe-input>
            <span v-else>{{scope.row.monetaryAmount}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="dateTime" title="日期时间">
          <template v-slot:header>
            <span style="color: red">*</span>日期时间
          </template>
          <template v-slot="scope">
            <vxe-input v-if="isEdit" v-model="scope.row.dateTime" type="datetime" placeholder="请选择"
                       @change="clearV()"></vxe-input>
            <span v-else>{{scope.row.dateTime}}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button v-if="!isEdit && isHavePermission('capAccount:edit')" type="primary" @click="goEdit" style="width: 100px;">编 辑</Button>
      <Button v-if="isEdit" @click="cancel" style="width: 100px;">取 消</Button>
      <Button v-if="isEdit" type="primary" @click="updateFund" style="width: 100px;">保 存</Button>
    </div>
  </div>
</template>
<script>
  import $api from '@/apiProvider';
  import getAuthOrization from "@/mixin/getAuthOrization";

  export default {
    props: ['payment_code', 'bank_code', 'vehicle_plate_color_code'],
    mixins: [getAuthOrization],
    data() {
      return {
        formData: {
          documentNumber: null,
          sendToProDateTime: null,
          carrier: null,
          actualCarrierId: null,
          vehicleNumber: null,
          vehiclePlateColorCode: null,
          remark: null,
        },
        capList: [{
          shippingNoteNumber: null,
          serialNumber: null,
          totalMonetaryAmount: null,
        }],
        payList: [{
          paymentMeansCode: null,
          recipient: null,
          receiptAccount: null,
          bankCode: null,
          sequenceCode: null,
          monetaryAmount: null,
          dateTime: null
        }],
        formRules: {
          paymentMeansCode: [{required: true, message: "请选择付款方式代码"}],
          recipient: [{required: true, message: "请输入收款方名称"}],
          receiptAccount: [{required: true, message: "请输入收款帐户信息"}],
          sequenceCode: [{required: true, message: "请输入流水号/序列号"}],
          monetaryAmount: [{required: true, message: "请输入实际支付金额"}],
          dateTime: [{required: true, message: "请选择日期"}],
        },
        isEdit: false,
        id: null
      }
    },
    mounted() {

    },
    methods: {
      generateTimeReqestNumber(date) {
        return date.getFullYear().toString() + this.pad2(date.getMonth() + 1) + this.pad2(date.getDate()) + this.pad2(date.getHours()) + this.pad2(date.getMinutes()) + this.pad2(date.getSeconds());
      },
      pad2(n) {
        return n < 10 ? '0' + n : n
      },
      async validEvent() {
        let errMap = await this.$refs.xTable2.validate().catch((errMap) => errMap);
        return errMap ? false : true;
      },
      clearV() {
        this.$refs.xTable2.clearValidate();
      },
      cancel() {
        this.clearV();
        this.isEdit = false;
      },
      showDetail(id) {
        this.id = id;
        this.isEdit = false;
        this.queryFundDetail(id);
      },
      setUpdate(id) {
        this.id = id;
        this.isEdit = true;
        this.queryFundDetail(id);
      },
      async updateFund() {
        let sts = await this.validEvent();
        if (!sts) {
          return;
        }
        let dateTime = this.generateTimeReqestNumber(this.$utils.toStringDate(this.payList[0].dateTime));
        let res = await $api.reportData.post('updateFund', {
          id: this.id,
          paymentMeansCode: this.payList[0].paymentMeansCode,
          recipient: this.payList[0].recipient,
          receiptAccount: this.payList[0].receiptAccount,
          bankCode: this.payList[0].bankCode,
          sequenceCode: this.payList[0].sequenceCode,
          monetaryAmount: this.payList[0].monetaryAmount,
          dateTime: dateTime,
        });
        if (res.status === 1) {
          this.$Message.success("修改成功");
          this.close();
          this.$emit('afterSave');
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      strDate(dateString) {
        const pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
        return new Date(dateString.replace(pattern, '$1/$2/$3 $4:$5:$6'));
      },
      async queryFundDetail(id) {
        this.clearV();
        let res = await $api.reportData.post('queryFundDetail', {
          id: id
        });

        if (res.status === 1) {
          let data = res.data;
          let date = null;
          if (data.dateTime) {
            date = this.strDate(data.dateTime);
          }
          this.capList = [{
            shippingNoteNumber: data.shippingNoteNumber,
            serialNumber: data.serialNumber,
            totalMonetaryAmount: data.totalMonetaryAmount,
          }];
          this.payment_code.map(i => {
            if (data.paymentMeansCode === i.value) {
              data.paymentMeansCodeText = i.label;
            }
          })
          this.bank_code.map(i => {
            if (data.bankCode === i.value) {
              data.bankCodeText = i.label;
            }
          })
          this.vehicle_plate_color_code.map(i => {
            if (data.vehiclePlateColorCode === i.value) {
              data.vehiclePlateColorCodeText = i.label;
            }
          })
          this.formData = {
            vehiclePlateColorCodeText: data.vehiclePlateColorCodeText,
            documentNumber: data.documentNumber,
            sendToProDateTime: data.sendToProDateTime,
            carrier: data.carrier,
            actualCarrierId: data.actualCarrierId,
            vehicleNumber: data.vehicleNumber,
            vehiclePlateColorCode: data.vehiclePlateColorCode,
            remark: data.remark,
          };
          this.payList = [{
            paymentMeansCodeText: data.paymentMeansCodeText,
            bankCodeText: data.bankCodeText,
            paymentMeansCode: data.paymentMeansCode,
            recipient: data.recipient,
            receiptAccount: data.receiptAccount,
            bankCode: data.bankCode,
            sequenceCode: data.sequenceCode,
            monetaryAmount: data.monetaryAmount,
            dateTime: date ? this.$utils.toDateString(new Date(date), "yyyy-MM-dd HH:mm:ss") : null
          }];
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      goEdit() {
        this.isEdit = true;
      },
      close() {
        this.formData = {
          documentNumber: null,
          sendToProDateTime: null,
          carrier: null,
          actualCarrierId: null,
          vehicleNumber: null,
          vehiclePlateColorCode: null,
          remark: null,
        };
        this.capList = [{
          shippingNoteNumber: null,
          serialNumber: null,
          totalMonetaryAmount: null,
        }];
        this.payList = [{
          paymentMeansCode: null,
          recipient: null,
          receiptAccount: null,
          bankCode: null,
          sequenceCode: null,
          monetaryAmount: null,
          dateTime: null
        }];
        this.isEdit = false;
        this.id = null;
      }
    }
  }
</script>

<style scoped>
  .block {
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }

  .block-tip {
    width: 4px;
    height: 16px;
    background: #539FFF;
  }

  .block-title {
    margin-left: 4px;
    height: 21px;
    font-size: 16px;
    font-weight: bold;
    line-height: 21px;
    color: #539FFF;
  }

  .modal-footer {
    box-sizing: border-box;
    padding: 10px 0;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    width: 98%;
    position: absolute;
    bottom: 0;
  }
</style>
